
enum MarketStateGroupEvaluationMethod {
	MIN = 'MIN', MAX = 'MAX', AVERAGE = 'AVERAGE'
}

export default  MarketStateGroupEvaluationMethod;